import GridViewIcon from "@mui/icons-material/GridView";
import { styled, Typography } from "@mui/material";

export const CustomTypography = styled(Typography)({
    fontFamily: "ArtifaktElement,sans-serif",
    fontSize: "14px",
    color: "#212121",
    padding: "0.3rem 0",
    marginLeft: "0.5rem",
});

export const CustomGridViewIcon = styled(GridViewIcon)({
    fontSize: "14px",
});
